import React, { useState, createRef, Fragment, useEffect } from 'react';
import {
  Row,
  Card,
  CardTitle,
  Label,
  Input,
  Button,
  FormGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Spinner,
  Alert,
  InputGroupAddon,
  CustomInput,
  InputGroup,
} from 'reactstrap';
import PasswordStrengthBar from 'react-password-strength-bar';
import ReactHtmlParser from "react-html-parser";
import aiva_logo from "./../../assets/aiva_logo.png";
import { NavLink } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { postAPI_Onboard, postAPI_EmailCheck } from '../../constants/APIs';
import { Colxx } from '../../components/common/CustomBootstrap';
import { Wizard, Steps, Step } from 'react-albus';
import BottomNavigation from '../../components/wizard/BottomNavigation';
import TopNavigation from '../../components/wizard/TopNavigation';
import { Formik, Form, Field } from 'formik';
import Select from 'react-select';
import country from '../../data/country';
import CatgeoryData from './../../data/voucherCategory.json';
import timeZoneList from '../../data/timeZoneList';
import currencyList from '../../data/currencyList';
import { reactSelectOptionDiffrentPro } from '../../helpers/Utils';
import { AxiosAPI, AxiosPublicAPI } from '../../helpers/AxiosAPI';
import {
  gAPI_Products_List,
  gAPI_Stripe_PromoCode,
} from '../../constants/APIs';
import ProductListItem from './components/ProductListItem';
import ProductListItemCompact from './components/ProductListItemCompact';
import CustomPlan from './components/CustomPlan';
import billingCurrencyList from '../../data/billingCurrencyList';
import { Tooltip } from 'reactstrap';
import AivaProductListItem from './components/AivaProductListItem';

function VoucherSignup() {
  const [selectedItem, setSelectedItem] = useState([]);
  const [tooltip, setToolTip] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [propertyNameToolTip, setPropertyNameToolTip] = useState(false);
  const [nameToolTip, setNameToolTip] = useState(false);
  const [emailToolTip, setEmailToolTip] = useState(false);
  const [selectZones, setSelectZones] = useState();
  const [productsList, setProductsList] = useState([]);
  const forms = [createRef(null), createRef(null), createRef(null)];
  const [bottomNavHidden, setBottomNavHidden] = useState(false);
  const [loading, setLoading] = useState(false);
  const [productVisible, setProductVisible] = useState(false);
  const [terms, setTerms] = useState(false);
  const [widthDiv, setwidthDiv] = useState('120%');
  const [buttonText, setButtonText] = useState("Go");
  const [countriesData, setCountriesData] = useState([]);
  const [isload, setIsload] = useState(true);
  const [isShow, setIsShow] = useState(false);
  let [title, settitle] = useState("Welcome to the world of <strong className='aiva-font'>aiva</strong>: a voucher distribution network for savvy tourism businesses!");
  let [subTitle, setSubTitle] = useState("Are you ready to take control of your digital marketing? It’s easy just sign up now.");
  const [propertyData, setpropertyData] = useState({
    name: '',
    website: '',
    type: 'Accommodation',
    country: '',
    timeZone: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    phoneNumber: '',
    currency: '',
    stripeProductId: '',
    stripePriceId: '',
    address: '',
    productId: 0,
    aivaProductId: '',
    priceId: 0,
    billingCurrency: '',
    promoId: '',
    promoCode: '',
    images: '',
    isBmb: false,
    isAiva: true
  });

  useEffect(() => {
    if (isload) {
      AxiosPublicAPI({
        method: 'get',
        url: `${"https://restcountries.com/v2/all"}`,
      })
        .then((res) => {
          setCountriesData(res.data);
        });
    }
    setIsload(false);
  }, [countriesData]);
  const handleProductId = (val) => {
    setpropertyData({ ...propertyData, aivaProductId: val });
  }
  const togglePropertyNameToolTip = () => {
    setPropertyNameToolTip(!propertyNameToolTip);
  };
  const toggleNameToolTip = () => {
    setNameToolTip(!nameToolTip);
  };
  const toggleEmailToolTip = () => {
    setEmailToolTip(!emailToolTip);
  };
  const toggle = () => {
    setProductVisible(!productVisible);
  };

  const LoadData = (currency) => {
    AxiosPublicAPI({
      methhod: 'get',
      url: `${gAPI_Products_List}?currency=${currency}&type=Voucher`,
    })
      .then((res) => {
        setProductsList(res.data);
        const params = new URLSearchParams(window.location.search);
        let product = params.get('product');
        if (product === null) {
          if (res.data.length >= 2) {
            let product = res.data[1];
            setpropertyData({
              ...propertyData,
              stripeProductId: product.productStripeId,
              stripePriceId: product.priceStripeId,
              productId: product.productId,
              priceId: product.pricingId,
            });
            setFormErrors({
              ...formErrors,
              productId: '',
            });
          }
        } else {
          let productArr = res.data.filter(
            (item) => item.productStripeId === product
          );
          if (productArr.length > 0) {
            setpropertyData({
              ...propertyData,
              stripeProductId: productArr[0].productStripeId,
              stripePriceId: productArr[0].priceStripeId,
              productId: productArr[0].productId,
              priceId: productArr[0].pricingId,
            });
            setFormErrors({
              ...formErrors,
              productId: '',
            });
          }
        }

        setLoading(false);
      })
      .catch((err) => null);
  };
  const handleCheckChange = (e) => {
    setTerms(e.target.checked);
  };
  const handleChange = (e) => {
    setpropertyData({
      ...propertyData,
      [e.target.name]: e.target.value,
    });
    setFormErrors({
      ...formErrors,
      [e.target.name]: '',
    });
  };

  const asyncLoading = () => {
    setLoading(true);
    // setTimeout(() => {
    //     setLoading(false);
    // }, 3000);
  };

  async function CheckEmail(email) {
    let isValid = true;
    await AxiosPublicAPI({
      method: 'post',
      url: `${postAPI_EmailCheck}`,
      data: {
        email: propertyData.email,
      },
    })
      .then((res) => {
        if (res.data.exists === true) {
          isValid = false;
          //errors.email = 'Email already registered with us.'
        }
      })
      .catch((err) => null);
    return isValid;
  }

  const onClickNext = (goToNext, steps, step) => {
    // settitle("");
    // setSubTitle("");
    const formIndex = steps.indexOf(step);
    const form = forms[formIndex].current;
    setFormErrors({});
    form.submitForm().then(async () => {
      let isValid = true;
      let errors = {};
      // // console.log(propertyData)
      if (formIndex == 0) {
        if (propertyData.name === '') {
          isValid = false;
          errors.name = 'Please enter property name';
        }
        if (propertyData.website === '') {
          isValid = false;
          errors.website = 'Please enter property website';
        }
        if (propertyData.address === '') {
          isValid = false;
          errors.address = 'Please enter business address';
        }
        if (propertyData.country === '') {
          isValid = false;
          errors.country = 'Please select country';
        }
      }
      if (formIndex == 1) {
        var passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{12,}$/;
        if (propertyData.firstName === '') {
          isValid = false;
          errors.firstName = 'Please enter first name';
        }
        if (propertyData.lastName === '') {
          isValid = false;
          errors.lastName = 'Please enter last name';
        }
        if (propertyData.email === '') {
          isValid = false;
          errors.email = 'Please enter email';
        }
        if (propertyData.phoneNumber === '') {
          isValid = false;
          errors.phoneNumber = 'Please enter phone number';
        }
        if (propertyData.password === '') {
          isValid = false;
          errors.password = 'Please enter password';
        } else {
          if (propertyData.password.length >= 12 && propertyData.password.length <= 16 &&
            /(?=.*[A-Z])/.test(propertyData.password) && /(?=.*[a-z])/.test(propertyData.password) &&
            /(?=.*[0-9])/.test(propertyData.password) && /(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(propertyData.password)) {
            isValid = true;
          } else {
            isValid = false;
            setIsShow(true);
          }
        }
        if (propertyData.confirmPassword === '') {
          isValid = false;
          errors.confirmPassword = 'Please enter confirm password';
        } else if (propertyData.password !== propertyData.confirmPassword) {
          isValid = false;
          errors.confirmPassword = 'Password and confirm password should match';
        }

        if (propertyData.email !== '') {
          if (
            !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
              propertyData.email
            )
          ) {
            errors.email = 'Invalid email address';
          } else {
            if ((await CheckEmail(propertyData.email)) === false) {
              isValid = false;
              errors.email = 'Email already registered with us.';
            }
          }
        }
      }
      let couponId = '';
      if (formIndex == 2) {
        // if (propertyData.stripeProductId === '') {
        //   isValid = false;
        //   errors.productId = 'Please subscribe to any 1 package';
        // }
        if (terms === false) {
          isValid = false;
          errors.terms = 'Please accept the terms and conditions first.';
        }
        if (propertyData.aivaProductId === '' || propertyData.aivaProductId === '2' || (propertyData.aivaProductId.includes(1) === false && propertyData.aivaProductId.includes(0) === false)) {
          isValid = false;
          errors.productId = 'Please select one package from Pay-As-You-Go and Pay-As-You-Go Gateway';
        }
        if (propertyData.promoCode !== '') {
          await AxiosPublicAPI({
            methhod: 'get',
            url: `${gAPI_Stripe_PromoCode}?code = ${propertyData.promoCode} `,
          }).then((res) => {
            if (res.data.promoCodes.length > 0) {
              couponId = res.data.promoCodes[0].coupon.id;
            } else {
              isValid = false;
              errors.promo = 'Promo code is invalid/expired. Please try again.';
            }
          });
        }
      }
      if (parseInt(step.id) + 1 === 1 && isValid) {

        settitle("Welcome to the world of <strong className='aiva-font'>aiva</strong> : a voucher distribution network for savvy tourism businesses!");
        setSubTitle("Are you ready to take control of your digital marketing? It’s easy just sign up now.");
      }
      if (parseInt(step.id) + 1 === 2 && isValid) {
        settitle("Awesome you are a step closer. Now we just need to get to know you a bit better.");
        setSubTitle("");
      }
      if (parseInt(step.id) + 1 === 3 && isValid) {
        settitle("Almost there, we just need to know you agree to the fine print!"); setButtonText("Good to go!")
        setSubTitle("");
      }
      setFormErrors(errors);

      if (isValid) {
        if (formIndex === 0) {
          LoadData(propertyData.currency);
          setwidthDiv('80%');
        } else if (formIndex === 1) {
          setwidthDiv('100%');
        }
        goToNext();
        step.isDone = true;
        if (steps.length - 2 <= steps.indexOf(step)) {
          setBottomNavHidden(true);
          asyncLoading();
          if (formIndex == 2) {
            propertyData.promoId = couponId;
            try {
              let values = window.location.href.substring(window.location.href.lastIndexOf("=") + 1
                , window.location.href.length);
              if (values !== '') {
                propertyData.data = values;
                propertyData.invitationType = 'SignUp';
                localStorage.removeItem('Invitation');
              }
            } catch { }
            propertyData.phoneNumber = countriesData.filter(f => f.alpha2Code === propertyData.country)[0].callingCodes[0] + propertyData.phoneNumber;
            AxiosPublicAPI({
              method: 'post',
              url: `${postAPI_Onboard}`,
              data: propertyData,
            })
              .then((res) => {

                if (res.data.invitationId !== undefined) {
                  localStorage.removeItem('Invitation');
                  localStorage.setItem("Invitation", res.data.invitationId);
                }
                setLoading(false);
              })
              .catch((err) => null);
          }
        }
      }
    });
  };
  const onClickPrev = (goToPrev, steps, step) => {
    if (parseInt(step.id) - 1 === 1) {
      settitle("Welcome to the world of <strong className='aiva-font'>aiva</strong> : a voucher distribution network for savvy tourism businesses!");
      setSubTitle("Are you ready to take control of your digital marketing? It’s easy just sign up now.");
      setButtonText("Go");
    }
    else if (parseInt(step.id) - 1 === 2) {
      settitle("Awesome you are a step closer. Now we just need to get to know you a bit better.");
      setSubTitle("");
      setButtonText("Go");
    }
    else if (parseInt(step.id) - 1 === 3) {
      settitle("Almost there, we just need to know you agree to the fine print!");
      setSubTitle("");
      setButtonText("Good to go!")
    }
    else if (parseInt(step.id) - 1 === 4) {
      settitle("");
      setSubTitle("");
      setButtonText("Good to go!")
    }
    setwidthDiv('80%');
    if (steps.indexOf(step) <= 0) {
      return;
    }
    goToPrev();
  };
  const SelectedProduct = (
    e,
    stripeProductId,
    stripePriceId,
    productId,
    priceId
  ) => {
    if (e.target.tagName !== 'A') {
      setpropertyData({
        ...propertyData,
        stripeProductId: stripeProductId,
        stripePriceId: stripePriceId,
        productId: productId,
        priceId: priceId,
      });
      setFormErrors({
        ...formErrors,
        productId: '',
      });
    }
  };

  const handleChangeSelect = (value, { name }) => {
    setFormErrors({
      ...formErrors,
      country: '',
    });
    let timeZone = '';
    let timeZones = timeZoneList.filter(
      (item) => item.IsoAlpha2 === value.value
    );
    if (timeZones.length > 0) {
      if (timeZones[0].TimeZones.length === 1) {
        timeZone = timeZones[0].TimeZones[0];
        setSelectZones(
          timeZones[0].TimeZones.map((zone) => {
            return <option value={zone}>{zone}</option>;
          })
        );
      } else {
        timeZone = timeZones[0].TimeZones[0];
        setSelectZones(
          timeZones[0].TimeZones.map((zone) => {
            return <option value={zone}>{zone}</option>;
          })
        );
      }
    }

    let currency = currencyList.filter(
      (item) => item.countryCode === value.value
    );
    if (currency.length > 0) {
      let billingCurrencyarr = billingCurrencyList.filter(
        (item) => item.countryCode === value.value
      );
      setpropertyData({
        ...propertyData,
        country: value.value,
        timeZone: timeZone,
        currency: currency[0].currencyCode,
        billingCurrency: billingCurrencyarr[0].currencyCode,
      });
    }
  };

  return (
    <Fragment>
      <Row className="h-100">
        <Colxx xxs="12" md="12" className="mx-auto my-auto">
          <Card className="auth-card">
            <div
              className="form-side wizard wizard-default voucher-singup "
              style={{ width: widthDiv }}
            >
              <div style={{ textAlign: 'center' }}>
                <NavLink to={'/user/vouchersignup'} className="white">
                  <span className="logo-single mb-2" style={{ marginBottom: '0px' }}>
                    {' '}
                    <img src={aiva_logo} onClick={() => window.open("https://www.getaiva.com")} width="150" />{' '}
                  </span>
                </NavLink>
                <CardTitle className="text-center text-dark">
                  {ReactHtmlParser(title.split(':')[0])}

                  <div className='my-1'> {ReactHtmlParser(title.split(':')[1])}</div>
                  <div className="text-center">
                    {ReactHtmlParser(subTitle)}
                  </div>
                </CardTitle>

              </div>
              <Wizard>
                {title !== '' && <TopNavigation className="justify-content-center" disableNav aiva={true} />}
                <Steps className="aiva">
                  <Step id="1" name="Step 1" desc="Business Details">
                    <div className="wizard-basic-step">
                      <Formik
                        innerRef={forms[0]}
                        initialValues={{}}
                        onSubmit={() => { }}
                      >
                        {({ errors, touched }) => (
                          <Form className="av-tooltip tooltip-label-right rounded">
                            <FormGroup>
                              <Label>
                                Business Name{' '}
                                <i
                                  className="demo-icon simple-icon-info"
                                  id="propertyNametip"
                                ></i>
                              </Label>
                              <Field
                                className="form-control"
                                name="name"
                                value={propertyData.name}
                                onChange={handleChange}
                              />
                              {formErrors.name && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.name}
                                </div>
                              )}
                              <Tooltip
                                placement="right"
                                isOpen={propertyNameToolTip}
                                target="propertyNametip"
                                toggle={togglePropertyNameToolTip}
                              >
                                If you are group, setup one business, you will be
                                able to add more later on.
                              </Tooltip>
                            </FormGroup>
                            <FormGroup>
                              <Label>Business Website </Label>
                              <Field
                                className="form-control"
                                name="website"
                                value={propertyData.website}
                                onChange={handleChange}
                              />

                              {formErrors.website && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.website}
                                </div>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label>Business Type</Label>
                              <Input
                                className=""
                                type="select"
                                value={propertyData.type}
                                name="type"
                                onChange={handleChange}
                              >

                                {CatgeoryData.data !== undefined &&
                                  CatgeoryData.data.map((m, index) => {
                                    return <option value={m.value} key={index}>{m.name}</option>;
                                  })}
                                <option value="TourismOrganisation" key="TourismOrganisation">Tourism Organisation</option>
                                <option value="Others" key="Others">Others</option>
                              </Input>
                            </FormGroup>
                            <FormGroup>
                              <Label>Business Address </Label>
                              <Field
                                className="form-control"
                                name="address"
                                value={propertyData.address}
                                onChange={handleChange}
                              />

                              {formErrors.address && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.address}
                                </div>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label>Country</Label>
                              <Select
                                isMulti={false}
                                className="react-select "
                                classNamePrefix="react-select"
                                name="code"
                                placeholder="Please Select Country"
                                onChange={handleChangeSelect}
                                options={
                                  country
                                    ? reactSelectOptionDiffrentPro(
                                      country,
                                      true,
                                      'code',
                                      'name',
                                      ''
                                    )
                                    : []
                                }
                              />
                              {formErrors.country && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.country}
                                </div>
                              )}
                            </FormGroup>
                            {selectZones !== undefined && selectZones.length > 1 && (
                              <FormGroup>
                                <Label>Time Zone</Label>
                                <Input
                                  name="timeZone"
                                  type="select"
                                  onChange={handleChange}
                                  value={propertyData.timeZone}
                                >
                                  {selectZones}
                                </Input>
                              </FormGroup>
                            )}
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </Step>
                  <Step id="2" className="aiva" name="Step 2" desc="User Details">
                    <div className="wizard-basic-step">
                      <Formik
                        innerRef={forms[1]}
                        initialValues={{}}
                        onSubmit={() => { }}
                      >
                        {({ errors, touched }) => (
                          <Form className="av-tooltip tooltip-label-right rounded">
                            <FormGroup>
                              <Label>
                                First Name{' '}
                                <i
                                  className="demo-icon simple-icon-info"
                                  id="nametip"
                                ></i>
                              </Label>
                              <Field
                                className="form-control"
                                name="firstName"
                                value={propertyData.firstName}
                                onChange={handleChange}
                              />
                              {formErrors.firstName && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.firstName}
                                </div>
                              )}
                              <Tooltip
                                placement="right"
                                isOpen={nameToolTip}
                                target="nametip"
                                toggle={toggleNameToolTip}
                              >
                                This is your first user account, and you will be
                                able to add your team members later on.
                              </Tooltip>
                            </FormGroup>
                            <FormGroup>
                              <Label>Last Name</Label>
                              <Field
                                className="form-control"
                                name="lastName"
                                value={propertyData.lastName}
                                onChange={handleChange}
                              />
                              {formErrors.lastName && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.lastName}
                                </div>
                              )}
                            </FormGroup>
                            <FormGroup>
                              <Label>
                                Business Email{' '}
                                <i
                                  className="demo-icon simple-icon-info"
                                  id="emailtip"
                                ></i>
                              </Label>
                              <Field
                                className="form-control"
                                name="email"
                                value={propertyData.email}
                                onChange={handleChange}
                              />
                              {formErrors.email && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.email}
                                </div>
                              )}
                              <Tooltip
                                placement="right"
                                isOpen={emailToolTip}
                                target="emailtip"
                                toggle={toggleEmailToolTip}
                              >
                                Your first account will be created with this email
                                address.
                              </Tooltip>
                            </FormGroup>
                            <FormGroup>
                              <Label>Phone Number</Label>
                              <InputGroup>
                                <InputGroupAddon>
                                  <UncontrolledDropdown className="vouchersignup_dropdown">
                                    <DropdownToggle
                                      caret
                                      color="light"
                                      size="sm"
                                      className="language-button vouchersignup_dropdown"
                                    >
                                      {countriesData.length > 0 && countriesData.filter(f => f.alpha2Code === propertyData.country).length > 0 &&
                                        <span className="name "><img className='phone_country_img mr-2'
                                          src={countriesData.filter(f => f.alpha2Code === propertyData.country)[0].flag}>
                                        </img>{countriesData.filter(f => f.alpha2Code === propertyData.country)[0].callingCodes[0]}</span>}
                                    </DropdownToggle>
                                    <DropdownMenu
                                      style={{ maxHeight: '205px', overflowY: 'auto' }}
                                      className="mt-3"
                                      right
                                    >
                                      {countriesData.map((c) =>
                                        <DropdownItem key={c.alpha2Code} onClick={() =>
                                          setpropertyData({ ...propertyData, country: c.alpha2Code })
                                        } value={c.alpha2Code}><div className='d-flex'>
                                            <img className='phone_country_img mr-2' src={c.flags.png}></img>
                                            {c.name + ' '}  {c.callingCodes[0]}</div>
                                        </DropdownItem>)}
                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </InputGroupAddon>
                                <Field
                                  className="form-control"
                                  name="phoneNumber"
                                  value={propertyData.phoneNumber}
                                  onChange={handleChange}
                                />
                                {formErrors.phoneNumber && (
                                  <div className="invalid-feedback aiva-border d-block">
                                    {formErrors.phoneNumber}
                                  </div>
                                )}

                              </InputGroup>


                            </FormGroup>
                            <div className='m-2'>
                              <h6>Your password must contain </h6>
                              <ul className='ml-3'>
                                <li className='mb-2'>Atleast 12 Characters (16 Maximum).</li>
                                <li className='mb-2'>Atleast one upper case letter.</li>
                                <li className='mb-2'>Atleast one lower case letter.</li>
                                <li className='mb-2'>Atleast one number.</li>
                                <li className='mb-2'>Atleast one of the following symbols (?=.*[@#$%^&-+=()]).</li>
                              </ul>
                            </div>
                            <FormGroup>
                              <Label>Password</Label>
                              <Field
                                id="Tooltip"
                                className="form-control"
                                type="password"
                                name="password"
                                value={propertyData.password}
                                onChange={handleChange}
                              />
                              {formErrors.password && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.password}
                                </div>
                              )}
                            </FormGroup>
                            <Tooltip
                              placement={'right'}
                              isOpen={tooltip}
                              target={"Tooltip"}
                              toggle={() => setToolTip(!tooltip)}
                            >
                              <p className='text-start' style={{ color: `${(propertyData.password.length >= 12 && propertyData.password.length <= 16) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Be 12 to 16 characters long</span></p>
                              <p className='text-start' style={{ color: `${/(?=.*[A-Z])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one upper case character</span></p>
                              <p className='text-start' style={{ color: `${/(?=.*[a-z])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one lower case character</span></p>
                              <p className='text-start' style={{ color: `${/(?=.*[0-9])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one number</span></p>
                              <p className='text-start' style={{ color: `${/(?=.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\])/.test(propertyData.password) ? 'green' : 'red'}` }}><img src="https://webchat.bookmebob.com/res/close_cross.png" width={10} height={10}></img><span className='ml-2'>Have atleast one special character</span></p>
                            </Tooltip>
                            {propertyData.password !== '' && <div className=""><PasswordStrengthBar minLength={12}
                              password={propertyData.password}></PasswordStrengthBar>
                            </div>}
                            <FormGroup>
                              <Label>Confirm Password</Label>
                              <Field
                                className="form-control"
                                type="password"
                                name="confirmPassword"
                                value={propertyData.confirmPassword}
                                onChange={handleChange}
                              />
                              {formErrors.confirmPassword && (
                                <div className="invalid-feedback aiva-border d-block">
                                  {formErrors.confirmPassword}
                                </div>
                              )}
                            </FormGroup>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </Step>
                  <Step id="3" className="aiva" name="Step 3" desc="Good to go!">
                    <div className="wizard-basic-step">
                      <Formik
                        innerRef={forms[2]}
                        initialValues={{}}
                        onSubmit={() => { }}
                      >
                        {({ errors, touched }) => (
                          <Form className="av-tooltip tooltip-label-right rounded">
                            <div className="equal-height-container row" style={{ marginLeft: "10%", marginRight: "10%" }}>
                              <AivaProductListItem
                                productId={propertyData.aivaProductId}
                                key={`product_item_`}
                                selectedItem={selectedItem}
                                handleSelecteditem={(e) => setSelectedItem(e)}
                                toggle={toggle}
                                handleProductId={handleProductId}
                                SelectedProduct={SelectedProduct}
                                SelectedProductID={
                                  propertyData.stripeProductId
                                }
                                w={4}
                                voucher={true}
                              />
                            </div>
                            {formErrors.productId && (
                              <Alert color="danger" className="rounded mt-2">
                                {formErrors.productId}
                              </Alert>
                            )}
                            {formErrors.terms && (
                              <Alert color="danger" className="rounded">
                                {formErrors.terms}
                              </Alert>
                            )}
                            {formErrors.promo && (
                              <Alert color="danger" className="rounded">
                                {formErrors.promo}
                              </Alert>
                            )}
                            <div className='mt-3' style={{ textAlign: 'center' }}>
                              <CustomInput
                                type="checkbox"
                                id="chkTerms"
                                checked={terms}
                                onChange={handleCheckChange}
                                name="terms"
                                label={
                                  <label>
                                    I agree to{' '}
                                    <a
                                      rel="noopener noreferrer"
                                      target="_blank"
                                      href="https://getaiva.com/terms-of-service"
                                      style={{ textDecoration: 'underline' }}
                                    >
                                      {' '}<strong>aiva</strong> Merchant Terms of Service
                                    </a>
                                  </label>
                                }
                              />
                            </div>
                            <div className="row text-center mb-3 d-none">
                              <div class="col-xs-4"></div>
                              <div class="col-xs-4">
                                {' '}
                                <Field
                                  className="form-control"
                                  type="text"
                                  name="promoCode"
                                  value={propertyData.promoCode}
                                  placeholder="Apply Promo Code"
                                  onChange={handleChange}
                                  width="150px"
                                />
                              </div>
                              <div class="col-xs-4"></div>
                            </div>
                            <Fragment>
                              <Modal
                                isOpen={productVisible}
                                toggle={toggle}
                                size="lg"
                                style={{ maxWidth: '1024px' }}
                              >
                                <ModalHeader toggle={toggle}>
                                  Packages
                                </ModalHeader>
                                <ModalBody>
                                  <div className="equal-height-container mb-5 row">
                                    <AivaProductListItem
                                      selectedItem={selectedItem}
                                      handleSelecteditem={(e) => setSelectedItem(e)}
                                      key={`product_item`}
                                      SelectedProduct={SelectedProduct}
                                      SelectedProductID={
                                        propertyData.stripeProductId
                                      }
                                      w={4}
                                      voucher={true}
                                    />

                                  </div>
                                </ModalBody>
                                <ModalFooter>
                                  <Button color="secondary" onClick={toggle}>
                                    Close
                                  </Button>
                                </ModalFooter>
                              </Modal>
                            </Fragment>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  </Step>
                  <Step id="4" hideTopNav>
                    <div className="wizard-basic-step text-center pt-3">
                      {loading ? (
                        <div>
                          <Spinner color="primary" className="mb-1" />
                          <p>Your request is in progress</p>
                        </div>
                      ) : (
                        <div>
                          <h2 className="mb-2">Thank You!</h2>
                          <p>
                            Your <strong>aiva</strong> signup completed successfully!. Once
                            verified, you will get notified via email. This could take upto 2 business days.
                          </p>
                          <p>
                            <Button className="mt-4 text-white" color="primary" onClick={() => { window.open("http://getaiva.com", '_blank'); }}>
                              Explore <strong>aiva</strong>
                            </Button>
                          </p>
                        </div>
                      )}
                    </div>
                  </Step>
                </Steps>
                <BottomNavigation
                  onClickNext={onClickNext}
                  onClickPrev={onClickPrev}
                  aiva={true}
                  className={`justify-content-center  ${bottomNavHidden && 'invisible'
                    } `}
                  prevLabel="Back"
                  nextLabel={buttonText}
                />

                <div class="my-3 text-center">
                  Who is <strong>aiva</strong>? <a href="#" onClick={() => window.open("https://www.getaiva.com")} ><u>Learn more</u></a>
                </div>
              </Wizard>
            </div>
          </Card>
        </Colxx>
      </Row>
      {/* <Modal isOpen={isShow} toggle={() => setIsShow(!isShow)}>
        <ModalHeader toggle={() => setIsShow(!isShow)}>
          Password
        </ModalHeader>
        <ModalBody>
          <h6 className="m--2">   Password length must be in between of 12 to 16 characters and its must have 1 upper case,
                        1 lower case, 1 digit and 1 special characters.</h6>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => setIsShow(!isShow)}>Close</Button>
        </ModalFooter>
      </Modal>     */}
    </Fragment>
  );
}

export default injectIntl(VoucherSignup);
